export default "__VITE_ASSET__Bgf_TNcn__"